import { Red500 } from '@zep-us/zus/tokens';
import { useTranslation } from 'next-i18next';
import { YoutubeFillIcon } from '@/icons';
import { AiButton, AiButtonIcon } from './AiButtonBase';
export const AiYoutubeButton = ({
  onOpenBuildAiModal,
  isFull
}: {
  onOpenBuildAiModal: () => void;
  isFull: boolean;
}) => {
  const {
    t
  } = useTranslation(['build']);
  return <AiButton icon={<AiButtonIcon className="bg-red-50" icon={<YoutubeFillIcon size={isFull ? 'sm' : 'xs'} fill={Red500} />} />} label={t('build:build.ai.youtube.extractLabel')} description={t('build:build.ai.youtube.extractDescription')} size={isFull ? 'full' : 'simple'} onClick={onOpenBuildAiModal} data-sentry-element="AiButton" data-sentry-component="AiYoutubeButton" data-sentry-source-file="AiYoutubeButton.tsx" />;
};